import * as React from 'react';
import { useContext } from "react";
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { AuthContext, FireactContext } from '../lib/core';
import { NavLink } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import GroupIcon from '@mui/icons-material/Group';
import WebIcon from '@mui/icons-material/Web';
import PaymentsIcon from '@mui/icons-material/Payments';
import Typography from '@mui/material/Typography';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function DashboardSubMenu(props) {
  //console.log("SubMenu props ", props);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const { authUser } = useContext(AuthContext);
  const {config} = useContext(FireactContext);
  const pathnames = config.pathnames;
  const accountUrl = pathnames.UserAccount;
  const ordersUrl = pathnames.ListOrders;
  const treatmentsUrl = pathnames.Treatments;
  const listSchedulesURL = (authUser.user && authUser.userType === "Nurse") ? pathnames.ListSchedules : pathnames.ListAppointments;
  const AgendaURL = (authUser.user && authUser.userType === "Nurse") ? pathnames.Agenda : pathnames.Landing;
  //console.log('listSchedulesURL', listSchedulesURL);
  
  return (
    <>
    {(<>
        <Button
          id="admin-customized-button"
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          disableElevation
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
          sx={{
            color: '#000',
            textTransform: 'none',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '&:hover': { backgroundColor: 'transparent' },
          }}
        >
          Dashboard
        </Button>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            'aria-labelledby': 'demo-customized-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
        {authUser.user && authUser.userType === "Nurse" && [
              <MenuItem key="agenda" onClick={
                  () => {
                      handleClose();
                      navigate(AgendaURL);
                  }} disableRipple>
              <EditCalendarIcon />
              Agenda
              </MenuItem>
        ]}
        {authUser.user && authUser.userType === "Nurse" && [
              <MenuItem key="payment" onClick={
                  () => {
                      handleClose();
                      navigate('/payment');
                  }} disableRipple>
              <PaymentsIcon />
              Payment
              </MenuItem>
        ]}
        <Divider textAlign="left" sx={{ my: 0.5 }} >
            <Typography
                color="text.secondary"
                display="block"
                variant="caption"
            >
                Manage
            </Typography>
        </Divider>
        {listSchedulesURL && [
               <MenuItem key="schedule" onClick={
                   () => {
                       handleClose();
                       navigate(listSchedulesURL);
                   }} disableRipple>
                 <GridViewOutlinedIcon />
                 Schedule
               </MenuItem>
        ]}
        {authUser.user && authUser.userType === "Nurse" && [
            <MenuItem key="treatments" onClick={
                () => {
                    handleClose();
                    navigate(treatmentsUrl);
                }} disableRipple>
                <FormatListBulletedIcon />
                Treatments
            </MenuItem>
        ]}
        {authUser.user && authUser.userType === "Nurse" && accountUrl && [
            <MenuItem key="service-account" onClick={
              () => {
                  handleClose();
                  navigate(accountUrl);
              }} disableRipple>
                 <AccountBalanceWalletOutlinedIcon />
               Service Account
           </MenuItem>
        ]}
        {authUser.user && authUser.userType === "Customer" && [
            <MenuItem key="orders" onClick={
                () => {
                    handleClose();
                    navigate(ordersUrl);
                }} disableRipple>
                <FormatListBulletedIcon />
                Orders
            </MenuItem>
        ]}
        </StyledMenu>
      </>)}
    </>
  );
}
